import {useDispatch, useSelector} from 'react-redux'
import {ClienteF} from '../../../../../interfaces/facturacion.interface'
import {State} from '../../../../../reducers'
import { useEffect } from 'react';
import { getMunicipios } from '../../../../../actions/catalogos.actions';
import InputPhone from '../../../../../components/Inputs/InputPhone';
import {telefonoParaInput} from '../../../../../utils/strings.utils'

const ViewDocV1 = () => {
  const {activeFactura} = useSelector((state: State) => state.historial);
  const receptor = activeFactura?.DetallesDTE?.receptor;

  const dispatch = useDispatch();

  const formCliente: ClienteF = useSelector((state: State) => state.facturacion.formCliente)
  const {tipoDocumento, departamentos, municipios, actividadesEconomicas} = useSelector(
    (state: State) => state.catalogos
  )

  useEffect(() => {
    const depa = receptor?.direccion?.departamento;
    if (depa && departamentos) {
      dispatch(getMunicipios(Number(depa), departamentos.find((depas) => depas.codigo === depa)?.valor, false))
    }
  }, [receptor?.direccion?.departamento, departamentos]);

  return (
    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ec6-0b1e6fa6' className='w-layout-cell'>
      <div className='card w-form'>
        <form
          className='form-content'
          data-wf-page-id='64b58c72be2b65200b1e6fa6'
          data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc'
        >
          <div>
            <h3 className='card-title l'>Datos del Cliente</h3>
          </div>
          <div className='form-separator'></div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='fecha' className='field-label m'>
                Fecha nota de crédito
              </label>
              <input autoComplete='off'
                type='date'
                className='m text-field w-input'
                name='fecha'
                data-name=''
                id='fecha'
                min='2000-01-01'
                value={formCliente.fecha}
                disabled={true}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='tipoDocumento' className='field-label m'>
                Tipo de documento
              </label>
              <select
                autoFocus
                id='tipoDocumento'
                name='tipoDocumento'
                data-name=''
                className='m text-field w-select'
                value={"36"}
                disabled={true}
              >
                <option value=''>Selecciona una opción</option>
                {tipoDocumento.filter(tp => tp.codigo === "36").map((tipo) => (
                  <option value={tipo?.codigo} key={tipo?.codigo}>
                    {tipo?.valor}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='numId' className='field-label m'>
                {'Número de Documento'}
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='numId'
                data-name='numId'
                placeholder={`Identificación`}
                id='numId'
                disabled={true}
                maxLength={20}
                value={receptor?.nit}
              />
            </div>
            <div className='label-input'>
              {/* <label htmlFor='nit' className='field-label m'>
                Cliente
              </label>
              <button type='button' className='m button' style={{justifyContent: 'start'}}>
                <img src={WhiteSearch} loading='lazy' alt='buscar' />
                <div>Buscar Cliente</div>
              </button> */}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='nombre' className='field-label m'>
                Nombre del cliente
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nombre'
                data-name=''
                placeholder='Nombre del cliente'
                id='nombre'
                disabled={true}
                maxLength={250}
                value={receptor?.nombre}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='departamento' className='field-label m'>
                Departamento
              </label>
              <select
                id='departamento'
                name='departamento'
                data-name=''
                className='m text-field w-select'
                disabled={true}
                value={receptor?.direccion?.departamento}
              >
                <option value=''>Selecciona una opción</option>
                {departamentos.map((tipo) => (
                  <option value={tipo?.codigo} key={tipo?.codigo}>
                    {tipo?.valor}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='municipio' className='field-label m'>
                Municipio
              </label>
              <select
                name='municipio'
                data-name=''
                id='municipio'
                className='m text-field w-select'
                disabled={true}
                value={receptor?.direccion?.municipio}
              >
                <option value=''>Selecciona una opción</option>
                {municipios.map((tipo) => (
                  <option value={tipo?.codigo} key={tipo?.codigo}>
                    {tipo?.valor}
                  </option>
                ))}
              </select>
            </div>
            <div className='label-input'>
              <label htmlFor='direccion' className='field-label m'>
                Dirección
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='direccion'
                data-name=''
                placeholder='Dirección'
                id='direccion'
                disabled={true}
                maxLength={200}
                value={receptor?.direccion?.complemento}
              />
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='email' className='field-label m'>
                Correo electrónico
              </label>
              <input autoComplete='off'
                type='email'
                className='m text-field w-input'
                name='email'
                data-name='Correo electrónico'
                placeholder='Correo electrónico'
                id='email'
                disabled={true}
                value={receptor?.correo}
              />
            </div>
            <div className='label-input'>
              <label htmlFor='telefono' className='field-label m'>
                Teléfono celular
              </label>
              <InputPhone
                className='m text-field w-input'
                name='telefono'
                value={telefonoParaInput(receptor?.telefono)}
                disabled={true}
                onChange={() => {}}
                onBlur={() => {}}
              />
              {/* <input autoComplete='off'
                type='tel'
                data-name='telefono'
                placeholder='(+503) 2341 4324'
                id='telefono'
                maxLength={30}
              /> */}
            </div>
          </div>
          <div className='w-layout-hflex h-inputs'>
            <div className='label-input'>
              <label htmlFor='actividad' className='field-label m'>
                Actividad
              </label>
              <select
                id='actividad'
                name='actividad'
                data-name='actividad'
                className='m text-field w-select'
                disabled={true}
                value={receptor?.codActividad}
                style={{textTransform: 'uppercase'}}
              >
                <option value=''>Selecciona una opción</option>
                {actividadesEconomicas.map((tipo) =>
                  tipo?.codigo?.trim() !== '' ? (
                    <option value={tipo?.codigo} key={tipo?.codigo}>
                      {tipo?.codigo} - {tipo?.valor}
                    </option>
                  ) : null
                )}
              </select>
            </div>
            <div className='label-input'>
              <label htmlFor='nrc' className='field-label m'>
                NRC
              </label>
              <input autoComplete='off'
                type='text'
                className='m text-field w-input'
                name='nrc'
                data-name='nrc'
                placeholder='NRC'
                id='nrc'
                disabled={true}
                value={receptor?.nrc}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ViewDocV1
